import * as THREE from 'three';

const vertexShader = `
  varying vec2 vUv;
  
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

const fragmentShader = `
  uniform sampler2D mapBaseColor;
  uniform sampler2D mapNormal;
  uniform sampler2D mapRoughness;
  uniform sampler2D mapStripes;
  
  uniform vec2 repeatBase;
  uniform vec2 offsetBase;
  uniform vec2 repeatStripes;
  uniform vec2 offsetStripes;
  uniform float stripesIntensity;
  
  varying vec2 vUv;
  
  void main() {
    // Base gravel textures
    vec2 uvBase = vUv * repeatBase + offsetBase;
    vec3 baseColor = texture2D(mapBaseColor, uvBase).rgb;
    vec3 baseNormal = texture2D(mapNormal, uvBase).rgb * 2.0 - 1.0;
    float baseRoughness = texture2D(mapRoughness, uvBase).r;
    
    // Stripes overlay with additive blend
    vec2 uvStripes = vUv * repeatStripes + offsetStripes;
    vec4 stripesTexel = texture2D(mapStripes, uvStripes);
    vec3 stripesColor = stripesTexel.rgb;
    float stripesAlpha = stripesTexel.a;
    
    // Add the stripes on top of base color
    vec3 finalColor = mix(baseColor, baseColor + stripesColor, stripesAlpha * stripesIntensity);
    
    // Composite normal (simple approach - blend normals)
    vec3 finalNormal = mix(baseNormal, stripesColor * 2.0 - 1.0, stripesAlpha * 0.5);
    
    gl_FragColor = vec4(finalColor, 1.0);
  }
`;

export function createStreetMaterial(textures) {
   const material = new THREE.ShaderMaterial({
      uniforms: {
         mapBaseColor: { value: textures.streetGravelBaseColor },
         mapNormal: { value: textures.streetGravelNormal },
         mapRoughness: { value: textures.streetGravelRoughness },
         mapStripes: { value: textures.streetStripes },
         repeatBase: { value: new THREE.Vector2(30.4, 30.4) },
         offsetBase: { value: new THREE.Vector2(0, 0) },
         repeatStripes: { value: new THREE.Vector2(29.1, 29.1) },
         offsetStripes: { value: new THREE.Vector2(0.78, 0) },
         stripesIntensity: { value: 2.0 },
      },
      vertexShader,
      fragmentShader,
      side: THREE.DoubleSide,
   });

   // Store uniforms on the material for easy access
   material.debugUniforms = {
      repeatBase: material.uniforms.repeatBase.value,
      offsetBase: material.uniforms.offsetBase.value,
      repeatStripes: material.uniforms.repeatStripes.value,
      offsetStripes: material.uniforms.offsetStripes.value,
      stripesIntensity: material.uniforms.stripesIntensity,
   };

   return material;
}
